import type { AnchorHTMLAttributes, Ref } from 'react';
import type React from 'react';

import { tailwindMerge } from '../../tailwind';

export interface LinkProps<T extends React.ElementType = 'a'>
  extends AnchorHTMLAttributes<HTMLAnchorElement> {
  as?: T;
  noStyle?: boolean;
  myRef?: Ref<HTMLAnchorElement>; // hack because forwardRef doesn't work with generics
}

/**
 * @deprecated Use Link component from shared folder instead
 */
export const Link = <T extends React.ElementType = 'a'>({
  className,
  children,
  noStyle,
  as,
  myRef,
  ...rest
}: LinkProps<T> &
  Omit<React.ComponentPropsWithoutRef<T>, keyof LinkProps<T>>) => {
  const Component = as || 'a';
  return (
    <Component
      {...rest}
      className={tailwindMerge(noStyle ? 'link-no-style' : 'link', className)}
      ref={myRef}
    >
      {children}
    </Component>
  );
};
